import { useState } from "react";
import type { CastMember } from "@/types/media";
import { getPerson } from "@/mocks/people";

interface CastListProps {
  cast: CastMember[];
}

export default function CastList({ cast }: CastListProps) {
  const [activeId, setActiveId] = useState<string | null>(null);

  return (
    <div className="flex gap-4 overflow-x-auto no-scrollbar pb-2">
      {cast.map((member) => {
        const person = getPerson(member.personId);
        if (!person) return null;
        const isOpen = activeId === person.id;
        return (
          <div
            key={member.personId + member.role}
            className="relative w-28 md:w-32 shrink-0"
            onMouseEnter={() => setActiveId(person.id)}
            onMouseLeave={() => setActiveId(null)}
            onClick={() => setActiveId(isOpen ? null : person.id)}
          >
            <div className="w-28 h-28 md:w-32 md:h-32 rounded-lg overflow-hidden bg-background-200">
              <img
                src={person.avatar}
                alt={`演员 ${person.name}`}
                title={`${person.name} 演员头像`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <p className="mt-2 text-sm font-medium text-foreground-950 truncate">{person.name}</p>
            <p className="text-xs text-foreground-500 truncate">{member.role}</p>

            {isOpen && (
              <div className="absolute z-30 left-0 bottom-full mb-2 w-56 p-3 rounded-lg bg-foreground-950 text-foreground-50 text-xs leading-relaxed shadow-lg animate-fade-in">
                <p className="font-semibold text-white mb-1">{person.name}</p>
                <p className="text-foreground-300">{person.bio}</p>
                <p className="mt-2 text-accent-400">演员详情页 · 敬请期待</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}